import MidlleInvitationABI from './abi/MiddleInvitationABI.json'

export { default as senderNFTABI } from './abi/senderNFTABI.json'
export { default as ERC20ABI } from './abi/ERC20ABI.json'
export { default as NFTABI } from './abi/NFTABI.json'
export { default as INCREASELPABI } from './abi/AddLpABI.json'
export { default as PANCEKEABI } from './abi/PancekeABI.json'
export { default as PinkABI } from './abi/PinkABI.json'
export { default as TokenV2ABI } from './abi/TokenV2ABI.json'
export { default as TokenV2ABIWrite } from './abi/TokenV2ABIWrite.json'
export { default as BNBTokenWriteABI } from './abi/BNBTokenWriteABI.json'
export { default as BabyTokenWriteABI } from './abi/BabyTokenWriteABI.json'
export { default as SenderTokenABI } from './abi/SenderTokenABI.json'
export { default as MintNFTABI } from './abi/MintNFTABI.json'
export { default as BOTABI } from './abi/bot.json'
export type { TokenType } from './token'
export { default as PancakeFactoryABI } from './abi/PancakeFactoryABI.json'
export { default as PancakeRouterABI } from './abi/PancakeRouterABI.json'
export { default as LPLockerABI } from './abi/LPLockerABI.json'
export { default as PancakeV3PositionsABI } from './abi/PancakeV3PositionsABI.json'

// v3锁池子 工厂合约
export const LPLockerAddress = {
  97: '0x49cA281a36e2458dc2Da026dA4Aea74e6038c2a7',
}
// 锁池子v3路由地址  代币添加到那个路由
export const SwapRouter = {
  97: [
    {
      label: 'PancakeSwap_V3',
      value: '0x1b81D678ffb9C0263b24A97847620C99d213eB14',
    },
  ],
}

// 批量发送合约
export const TOOLFACTORY = {
  56: '0xF8Ae467E58cfC0f458AAD907D6d2D95fA0026f72',
  97: '0x10DAdE1737733E0bc43a347455Bce435e2D1dF54',
  42161: '0x1eE7f7DBe6aa0AC2374Bf86A5597028d81069eBE',
  7899: '0x1F7907250992923450e6F599Bb91B3308A9eaadd',
  1: '0x1eE7f7DBe6aa0AC2374Bf86A5597028d81069eBE',
  12133: '0x53C7A70eBd762aBA076E1B0c2Ab97f45Dc8e22e4',
  1116: '0xa290c5Bb06Eaf009634ae3D0F15B4345c2F9F6aE',
  8453: '0xc24339a5D1933316cd5c2e712fb4402b8fa4D026',
  204: '0x1F7907250992923450e6F599Bb91B3308A9eaadd',
  128: '0xeF731549CDfa3fca8d45CFEcCc2fC62E8E974fC3',
  20201022: '0x0521af587fB12555F1E5beD4211dBb01A5A67E29',
  196: '0x1F7907250992923450e6F599Bb91B3308A9eaadd',
  33139: '0x1F7907250992923450e6F599Bb91B3308A9eaadd',
  137: '0xFC47E7f97E53a001279190dBa434EfA350161a35',

}

export const TOOLPRICE = {
  56: '0.02',
  97: '0',
  42161: '0',
  7899: '0',
  1: '0',
  12133: '0',
  1116: '1',
  8453: '0.0005',
  204: '0',
  128: '0',
  20201022: '0',
  196: '0.2',
  33139: '1',
  137: '10',
}

//锁池子地址合约
export const PinkContractAddress = {
  1: `0x71B5759d73262FBb223956913ecF4ecC51057641`,
  56: '0x407993575c91ce7643a4d4cCACc9A98c36eE1BBE',
  97: '0x5E5b9bE5fd939c578ABE5800a90C566eeEbA44a5',
  10001: `0x9e2B5bAb9e7e30d7E3689A6699ae15c2F46d02C9`,
  513100: `0x1F7907250992923450e6F599Bb91B3308A9eaadd`,
  42161: '0xeBb415084Ce323338CFD3174162964CC23753dFD',
  7899: '0xCcC4f81DC0ab3DeD060135250F21da78f7EDd271',
  12133: '0xC662906621b0d15AD0A4969418a288fB5F3fb38E',
  1116: '0x233891d32408818cD328818Cc7355bE3f0A0122f',
  8453: '0xA7D3A50FF7867C88326C7932e0284154880Bac59',
  204: '0xA7D3A50FF7867C88326C7932e0284154880Bac59',
  128: '0x34eB54474843E80bA8251B2314527D6bEfD202B5',
  20201022: '0xc24339a5D1933316cd5c2e712fb4402b8fa4D026',
  196: '0xA7D3A50FF7867C88326C7932e0284154880Bac59',
  33139: '0xA7D3A50FF7867C88326C7932e0284154880Bac59',
  137: '0x9e2B5bAb9e7e30d7E3689A6699ae15c2F46d02C9',

}

//  查询合约 工厂合约
export const LOCKCONTRACT = {
  56: '0xc149B12D7B185b0b4d3a39bfD34600C5423D18d9',
  97: '0x2D8b8c6fd4C36695300B053Fd3BB6034A33a5167',
  42161: '0xc35dadb65012ec5796536bd9864ed8773abc74c4',
  1: '0x5B6f77805C0C949eE61CD9e0D543711C9FCd4191',
  1116: '0xc239938ac88F1e2163d581F7cf2AA58C7Ce7f0a9',
  12133: '0xAaD3183518f37B17a52BaEF145d73D2515e7894F',
  196: '0xD16E3763Db63761CD5b38214EdC062FB43776CA3',
  33139: '0x67f766bDBe337eA2983c480b0898f6bc3F0DF4dA',
  137: '0x9a2E752a6b8e80bDa9e12A393F6bd269CD97F6b8',
}
// 路由工厂地址
export const PANCAKE_FACTORY = {
  56: '0xca143ce32fe78f1f7019d7d551a6402fc5350c73',
  97: '0x6725F303b657a9451d8BA641348b6761A6CC7a17',
  7899: '0x22607b7a8E16De60C98d01C16a34579aec0589A6',
  1: '0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f',
  12133: '0x872CF2b748E594d766500f75005E9Cd7E59508a7',
  // 1116: '0xA1ADD165AED06D26fC1110b153ae17a5A5ae389e',
  1116: '0x425E4b9f455849671De93d02A2D6eb132355274E',
  8453: '0x9a2E752a6b8e80bDa9e12A393F6bd269CD97F6b8',
  196: '0xa7afb6163c331ddb0845843889d6f9544328846f',
  33139: '0x06f2b773a8dD3021e51FC024BeE1e942b796BEe7',
  137: '0x9e5A52f57b3038F1B8EeE45F28b3C1967e22799C',
}

// 主链地址
// export const MAINADDRESS = ['0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c', '0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd']

//每个 主链合约地址
export const SenderMainInfo = {
  56: [{ name: `BNB`, address: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c' }],
  97: [{ name: `TBNB`, address: '0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd' }],
  128: [{ name: `HECO`, address: '0x5545153CCFcA01fbd7Dd11C0b23ba694D9509A6F' }],
  10001: [{ name: `ETHW`, address: '0x7Bf88d2c0e32dE92CdaF2D43CcDc23e8Edfd5990' }],
  513100: [{ name: `ETF`, address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2' }],
  42161: [{ name: 'WETH', address: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1' }],
  1116: [{ name: 'CORE', address: '0x40375C92d9FAf44d2f9db9Bd9ba41a3317a2404f' }],
  8453: [{ name: 'WETH', address: '0x4200000000000000000000000000000000000006' }],
  204: [{ name: 'opBNB', address: '0x4200000000000000000000000000000000000006' }],
  196: [{ name: 'WOKB', address: '0xe538905cf8410324e03A5A23C1c177a474D59b2b' }],
  1: [{ name: 'WETH', address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2' }],
  33139: [{ name: 'WAPE', address: '0x48b62137EdfA95a428D35C09E44256a739F6B557' }],
  137: [{ name: 'WPOL', address: '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270' }],
}

// 宝贝token分红依赖合约
export const BABYTOKENCONTRACT = {
  1: `0x0E1757b9d6501e60B2e4Ca0D000e49532948CF6c`,
  56: '0x8e268141DaF54aA1fcdB5574A72feB0eC2fC3970',
  97: '0x6d78A4A7F840C09FDF5Af422a4FBDFA99E250Bee',
  10001: `0xB9B53d2D25B4b2aDe84F5607359A180f2E1B793F`,
  513100: `0x67f766bDBe337eA2983c480b0898f6bc3F0DF4dA`,
  42161: '0x37dcBbeaC40471810DA2bc4B964e66fD277e8537',
  7899: '0x338F812Cd8889448A2dfFFD2d9e78a7C69A57D54',
  1116: '0xB9F47fD066a25Ed7C3ba8488cDccf79740AD4A05',
  12133: '0x61539d33959ff31Ea0Ea2D477F55EC66ab60F98e',
  8453: '0x338F812Cd8889448A2dfFFD2d9e78a7C69A57D54',
  204: '0x3282E68Cb7fe7841fce498B00c3D764AEf12bAdd',
  128: '0x564827Fd82117A651b90c4c2E0E965080C7322a6',
  196: '0x338F812Cd8889448A2dfFFD2d9e78a7C69A57D54',
  33139: '0x3282E68Cb7fe7841fce498B00c3D764AEf12bAdd',
  137: '0x9308AC4052ab225293121A57d2aed6eDcA2421DF',

}

//机器人合约
export const BOTCONTRACT = {
  56: '0x5302d4acbb0ba16154a44ea34aa58ccd0e6de222',
  97: '0xC6A1E571DEf14F6e8A1D71cb55364Ba250Bd7Ce7',
  128: '0xB9F47fD066a25Ed7C3ba8488cDccf79740AD4A05',
  12133: '0xFC47E7f97E53a001279190dBa434EfA350161a35',
}
//单独代币开通市值会员
export const TOKENBOTCONTRACT = {
  address: {
    56: '0x0D3ecC6949D345D88B9AAbB11A4e7a12c14D0144',
    97: '0xf80473f4685Db248077556915c5E74234eDB807c',
  },
  abi: MidlleInvitationABI,
  price: {
    1: '0.1',
    56: '0.1',
    97: '0.1',
  },
}

// 代币挖NFT工厂合约
export const MintNFTContract = {
  56: '0x523230A9c7083Bc033860E9EEcE1715DD0Ce088E',
  97: '0x0AA4f8bE86fC1fE79BBfCad9C1C37096567FC969',
}
